import { render, staticRenderFns } from "./InformationActions.vue?vue&type=template&id=532335be&scoped=true&"
import script from "./InformationActions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InformationActions.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./InformationActions.vue?vue&type=style&index=0&id=532335be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532335be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532335be')) {
      api.createRecord('532335be', component.options)
    } else {
      api.reload('532335be', component.options)
    }
    module.hot.accept("./InformationActions.vue?vue&type=template&id=532335be&scoped=true&", function () {
      api.rerender('532335be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuInformation/components/InformationActions.vue"
export default component.exports